import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

export default function BookingSuccess() {
  const navigate = useNavigate();

  const goHome = () => {
    try {
      if (window.top !== window.self) {
        window.top.location.href = window.location.origin + "/";
        return;
      }
    } catch {}
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-[#F4F4F6] flex items-center justify-center px-6" data-testid="booking-success-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="text-center flex flex-col items-center gap-6 max-w-md">
        <span className="border border-[#E63946] text-[#E63946] rounded-full p-4">
          <Check size={32} />
        </span>
        <h1 className="font-display uppercase text-5xl sm:text-6xl tracking-wide" data-testid="booking-success-title">
          Pedido enviado!
        </h1>
        <p className="text-zinc-400 text-base sm:text-lg" data-testid="booking-success-text">
          Em breve entraremos em contacto.
        </p>
        <button onClick={goHome} data-testid="booking-success-home-button"
          className="mt-2 bg-white text-black font-mono2 text-[11px] tracking-[0.25em] uppercase px-8 py-4 hover:bg-[#E63946] hover:text-white transition-colors duration-300">
          Voltar ao início
        </button>
      </motion.div>
    </div>
  );
}
